import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get(
      "session_id"
    );
    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("auth failed");
        const user = await res.json();
        navigate("/", { state: { user }, replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate]);

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-[#05060F]"
      data-testid="auth-callback"
    >
      <span className="pulse-dot h-3 w-3 rounded-full bg-teal-400" />
    </div>
  );
}
